import { useState } from "react";
import { styled } from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { usePageContentContext } from "../../contexts/PageContentProvider";
import logger from "../../server/server";
import { Filters } from "../App/Filter/Filters";
import { Footer } from "../App/Footer";
import { Header } from "../App/Header";
import { Configurations } from "./Configurations";
import { Homepage } from "./Homepage";
import { Map } from "./Map";
import { Register } from "./Register";
import { RegisterDetail } from "./RegisterDetail";
import { Analytic } from "./Analytic";
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: clip;
`;

const MainContent = styled.div`
    display: flex;
    height: calc(100% - 88px);
    /* overflow: hidden; */
    /* flex-direction: column; */
    /* min-height: 100vh - 93px; */
`;

const RightContent = styled.div`
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 100%;
    overflow-y: auto;
    justify-content: space-between;
`;

const FiltersContainer = styled.div`
    display: block;
    z-index: 1;
`;
//#endregion

export const RIGHT_CONTENT_ID = 'RightContent';

export function Home() {
    const [name, setName] = useState(null);
    const { user, tenant } = useAuthContext();
    const { withFilters, currentPath } = usePageContentContext();

    function renderPage(currentPath) {
        try {
            if (currentPath) {
                const zones = JSON.parse(localStorage.getItem('unified_nova_zones'));
                if (currentPath?.includes('/map') && zones?.includes('map')) {
                    logger.info('User ' + user + ' went to map page! Tenant: ' + tenant)
                    return <Map subEntity={name} />;
                }
                if (currentPath?.includes('/registry/item') && zones?.includes('registry')) {
                    logger.info('User ' + user + ' went to registry item page! Tenant: ' + tenant)
                    return <RegisterDetail />;
                }
                if (currentPath?.includes('/registry') && zones?.includes('registry')) {
                    logger.info('User ' + user + ' went to register page! Tenant: ' + tenant)
                    return <Register />;
                }
                if (currentPath?.includes('/configurations') && zones?.includes('configurations')) {
                    logger.info('User ' + user + ' went to configurations page! Tenant: ' + tenant)
                    return <Configurations />;
                }
                if (currentPath?.includes('/analytics') && zones?.includes('analytics')) {
                    // logger.info('User went to analitics');
                    return <Analytic />;
                }
                else {
                    return <Homepage />;
                }
            }
        } catch (error) {
            console.error('(Home page) Error in rendering Page currenntPath:', error);
            //reportError(error); // Send error report to backend
            logger.error("(Home page) User " + user + " Tenant: " + tenant + ', Error in rendering Page currenntPath:', error)
        }
    }

    return (
        <Container>
            <Header />
            <MainContent>
                {withFilters ?
                    <FiltersContainer>
                        <Filters />
                    </FiltersContainer>
                    : null
                }
                
                <RightContent id={RIGHT_CONTENT_ID}>
                    {renderPage(currentPath)}
                    {!currentPath?.includes('/map') && !currentPath?.includes('/registry/item') && !currentPath?.includes('/configurations') ? <Footer /> : null}
                </RightContent>
            </MainContent>
        </Container>
    );
}